module.exports = __webpack_public_path__ + "static/GTAmerica-Medium-44b2c41a93d19cb3974a642a9958beba.woff2";